module.exports = __webpack_public_path__ + "static/process1-11e29c454d7bbff563a9af21e98077ed.svg";